// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"411":"24f5433a","627":"c359b0fe","649":"45e27d00","741":"5216fb85","995":"3ccc88a4"}[chunkId] + ".css";
};